import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Icon, InputWithIcon, ExpandedTooltip } from '@livable/saas-react-components';
import { Button, Menu, Divider,
// ListSubheader,
Typography, TextField, MenuItem, Checkbox, ListItemText } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { useStore } from 'src/stores';
import useStyles from './styles';
export const PropertiesNavFilterMenu = observer(_ref => {
  var _store$homeDashboardS4, _store$homeDashboardS5, _store$homeDashboardS7;
  let listItems = _ref.listItems,
    menuTriggerExternal = _ref.menuTriggerExternal;
  const classes = useStyles();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showSecondLevel = _useState2[0],
    setShowSecondLevel = _useState2[1];
  const _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    anchorEl = _useState4[0],
    setAnchorEl = _useState4[1];
  const open = Boolean(anchorEl);
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
    setShowSecondLevel(false);
  };
  const MenuTriggerInternal = () => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, t('general.to_do')), /*#__PURE__*/React.createElement(Icon, {
      type: "triangle-down"
    }));
  };
  const SecondFilterLevel = observer(_ref2 => {
    let propertiesList = _ref2.propertiesList,
      resetSearchTrigger = _ref2.resetSearchTrigger,
      closeSecondLevel = _ref2.closeSecondLevel,
      handleCloseMenu = _ref2.handleCloseMenu;
    const _useState5 = useState(''),
      _useState6 = _slicedToArray(_useState5, 2),
      searchKey = _useState6[0],
      setSearchKey = _useState6[1];
    const handleSearchKeyChange = e => {
      setSearchKey(e.target.value);
    };
    const getListItems = () => {
      return propertiesList.filter(i => {
        const searchPhrase = new RegExp(searchKey, 'gi');
        return searchKey.length > 0 ? " ".concat(i.dashboard.propertyAddress).search(searchPhrase) > 0 : true;
      });
    };
    useEffect(() => {
      setSearchKey('');
    }, [resetSearchTrigger]);
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
      variant: "menuAction",
      className: classes.returnFromSecondFilterLevel,
      onClick: event => {
        event.stopPropagation();
        closeSecondLevel();
      },
      'custom-attribute': '380-PropertiesNavFilterMenu'
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "arrow-down",
      state: "dark"
    }), /*#__PURE__*/React.createElement(Typography, {
      variant: "h6"
    }, 'Filter by property')), /*#__PURE__*/React.createElement("div", {
      className: classes.searchField
    }, /*#__PURE__*/React.createElement(InputWithIcon, {
      icon: /*#__PURE__*/React.createElement(Icon, {
        type: "search"
      })
    }, /*#__PURE__*/React.createElement(TextField, {
      variant: "outlined",
      fullWidth: true,
      placeholder: t('general.search'),
      value: searchKey,
      onChange: handleSearchKeyChange
    }))), /*#__PURE__*/React.createElement(Divider, {
      className: classes.dividerNoBottomMargin
    }), /*#__PURE__*/React.createElement("div", {
      className: classes.filterMultiselectContainer
    }, getListItems().map(item => {
      var _store$homeDashboardS2, _item$dashboard;
      return /*#__PURE__*/React.createElement(MenuItem, {
        className: classes.filterMultiselectItem,
        key: item.id,
        value: item.id,
        variant: "multiple",
        onClick: event => {
          var _store$homeDashboardS;
          event.stopPropagation();
          event.stopPropagation();
          (_store$homeDashboardS = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS === void 0 || _store$homeDashboardS.propertyNavOptions.toggleItemSelection(item.id);
        },
        'custom-attribute': '381-PropertiesNavFilterMenu'
      }, /*#__PURE__*/React.createElement(Checkbox, {
        checked: (_store$homeDashboardS2 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS2 === void 0 ? void 0 : _store$homeDashboardS2.propertyNavOptions.isItemSelected(item.id)
      }), /*#__PURE__*/React.createElement(ListItemText, {
        primary: item === null || item === void 0 || (_item$dashboard = item.dashboard) === null || _item$dashboard === void 0 ? void 0 : _item$dashboard.propertyAddress
      }));
    })), /*#__PURE__*/React.createElement(Divider, {
      className: classes.dividerNoTopMargin
    }), /*#__PURE__*/React.createElement("div", {
      className: classes.secondLevelActionBtns
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "text",
      size: "small",
      className: classes.sortAscOption,
      onClick: event => {
        var _store$homeDashboardS3;
        event.stopPropagation();
        (_store$homeDashboardS3 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS3 === void 0 || _store$homeDashboardS3.propertyNavOptions.resetFilterOptions();
        // setShowSecondLevel(false);
      },
      'custom-attribute': '382-PropertiesNavFilterMenu'
    }, 'Reset'), /*#__PURE__*/React.createElement(Button, {
      variant: "contained",
      size: "small",
      className: classes.sortAscOption,
      onClick: event => {
        event.stopPropagation();
        handleCloseMenu();
      },
      'custom-attribute': '383-PropertiesNavFilterMenu'
    }, 'Close')));
  });
  return /*#__PURE__*/React.createElement("span", {
    onClick: e => e.stopPropagation(),
    onKeyDown: e => e.stopPropagation(),
    role: "button",
    tabIndex: 0
  }, /*#__PURE__*/React.createElement(ExpandedTooltip, {
    title: t('general.sort_and_filter'),
    placement: 'top',
    type: "info"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    className: classes.filterDropdown,
    id: "action-menu-trigger",
    "aria-controls": "action-menu",
    "aria-haspopup": "true",
    "aria-expanded": open ? 'true' : undefined,
    "aria-label": "resident menu",
    onClick: handleClick,
    state: open || !((_store$homeDashboardS4 = store.homeDashboardStore.getCurrentCompany) !== null && _store$homeDashboardS4 !== void 0 && _store$homeDashboardS4.propertyNavOptions.isFilterDefault) ? 'active' : undefined,
    'custom-attribute': '384-PropertiesNavFilterMenu'
  }, menuTriggerExternal !== undefined ? menuTriggerExternal : /*#__PURE__*/React.createElement(MenuTriggerInternal, null))), /*#__PURE__*/React.createElement(Menu, {
    type: "action-menu",
    id: "action-menu",
    MenuListProps: {
      'aria-labelledby': 'action-menu-trigger'
    },
    anchorEl: anchorEl,
    open: open,
    onClose: handleClose,
    elevation: 0,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'right'
    }
  }, !showSecondLevel ? /*#__PURE__*/React.createElement("div", null, ((_store$homeDashboardS5 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS5 === void 0 ? void 0 : _store$homeDashboardS5.propertyNavOptions.selectedSortOrder) !== 'asc' && /*#__PURE__*/React.createElement(Button, {
    variant: "menuAction",
    className: classes.sortAscOption,
    onClick: event => {
      var _store$homeDashboardS6;
      event.stopPropagation();
      (_store$homeDashboardS6 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS6 === void 0 || _store$homeDashboardS6.propertyNavOptions.setSortOrder('asc');
      handleClose();
    },
    'custom-attribute': '385-PropertiesNavFilterMenu'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "arrow-down"
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, 'Sort ASC')), ((_store$homeDashboardS7 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS7 === void 0 ? void 0 : _store$homeDashboardS7.propertyNavOptions.selectedSortOrder) !== 'desc' && /*#__PURE__*/React.createElement(Button, {
    variant: "menuAction",
    onClick: event => {
      var _store$homeDashboardS8;
      event.stopPropagation();
      (_store$homeDashboardS8 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS8 === void 0 || _store$homeDashboardS8.propertyNavOptions.setSortOrder('desc');
      handleClose();
    },
    'custom-attribute': '386-PropertiesNavFilterMenu'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "arrow-down"
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, 'Sort Desc')), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Button, {
    className: classes.filterByPortfoliosOption,
    variant: "menuAction",
    onClick: event => {
      event.stopPropagation();
      setShowSecondLevel(true);
    },
    'custom-attribute': '390-PropertiesNavFilterMenu'
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, 'Filter by properties'), /*#__PURE__*/React.createElement(Icon, {
    type: "arrow-line-right"
  }))) : /*#__PURE__*/React.createElement(SecondFilterLevel, {
    propertiesList: listItems,
    resetSearchTrigger: showSecondLevel,
    closeSecondLevel: () => setShowSecondLevel(false),
    handleCloseMenu: handleClose
  })));
});